import { render, staticRenderFns } from "./EditMailingTemplatePage.vue?vue&type=template&id=6996ca1d&scoped=true&"
import script from "./EditMailingTemplatePage.vue?vue&type=script&lang=js&"
export * from "./EditMailingTemplatePage.vue?vue&type=script&lang=js&"
import style0 from "./EditMailingTemplatePage.vue?vue&type=style&index=0&id=6996ca1d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6996ca1d",
  null
  
)

export default component.exports